import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const AddBranch = () => {
  const navigate = useNavigate();
  const { baseUrl, openToast,fetchBranch } = useGlobalContext();
  const [branchName, setBranchName] = React.useState("");
  const [isLoading, setIsLoading] = useState(false);
  async function addBranch() {
    setIsLoading(true);
    try {
      
      const result = await fetch(baseUrl + "branch", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ branchName: branchName }),
      });
      if (result.status == 201) {
        openToast("Branch Added Successfully", "success");
        setIsLoading(false);
        navigate("/branch-details");
        fetchBranch();
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="p-[20px] w-[100%] addnewrole">
      <h2 className="font-medium text-[#27004a] text-[18px]">Add New Branch</h2>

      <div className="w-[100%]">
        <div className="bg-[#fff] set-shadow mt-2 p-3 rounded-md w-[100%] md:w-[80%] lg:w-[50%] xl:w-[50%]">
          <label>Branch Name</label>
          <br />
          <input
            type="text"
            className="border-1 mt-2 pr-7 pl-3 border rounded-md w-[100%] h-[43px] text-[#aeabab] text-[15px] ] focus:outline-none"
            onChange={(e) => setBranchName(e.target.value)}
          />
          <div className="flex justify-end gap-[10px] mt-3 text-end">
            <Link
              to="/branch-details"
              className="flex items-center hover:bg-[#7526d1] py-2 pt-2 pr-5 pl-5 rounded-md text-white first-btn"
            >
              Cancel
            </Link>
            <button
              className={`${
                isLoading == true ? "second-btn-disabled" : "second-btn"
              }`}
              onClick={addBranch}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBranch;
